import {
    ContextualMenu, IContextualMenuItem, IContextualMenuStyleProps, IContextualMenuStyles, ILinkStyleProps, ILinkStyles, IStyleFunctionOrObject, Link, Stack, Text
} from "@fluentui/react";
import { ChevronDownIcon } from "@fluentui/react-icons-mdl2";
import { ArrayToLookupByKey } from "global/Utility/TSFunctions";
import React, { CSSProperties, useMemo, useRef, useState } from "react";

interface ILinkMenuStyles {
    root?: CSSProperties;
    link?: IStyleFunctionOrObject<ILinkStyleProps, ILinkStyles>;
    contextMenu?: IStyleFunctionOrObject<IContextualMenuStyleProps, IContextualMenuStyles>;
}

interface ILinkMenuProps {
    menuItems: IContextualMenuItem[];
    selectedKey: string;
    onChange?: (event: any, menuItem: IContextualMenuItem) => void;
    disabled?: boolean;
    styles?: ILinkMenuStyles
}

const LinkMenu: React.FunctionComponent<ILinkMenuProps> = (props) => {
    const [showContextualMenu, setShowContextualMenu] = useState(false);

    const linkRef = useRef(null);

    const menuItems = useMemo(() => {
        return ArrayToLookupByKey(props.menuItems, 'key');
    }, []);

    return <div style={props.styles?.root}>
        <Link
            styles={props.styles?.link}
            ref={linkRef}
            onClick={(event) => {
                event.preventDefault(); // don't navigate
                setShowContextualMenu(true);
            }}
            disabled={props.disabled}
        >
            <Stack horizontal verticalAlign="center">
                <Text variant='small' style={{ fontWeight: 600, fontSize: '10px' }}>{menuItems[props.selectedKey]?.text}</Text>
                <ChevronDownIcon style={{ fontSize: '6px', paddingLeft: '6px' }} />
            </Stack>
        </Link>
        <ContextualMenu
            styles={props.styles?.contextMenu}
            items={props.menuItems}
            hidden={!showContextualMenu}
            target={linkRef}
            onItemClick={(event, item) => {
                setShowContextualMenu(false);
                if (item)
                    props.onChange?.(event, item)
            }}
            onDismiss={(event, dismissAll) => {
                setShowContextualMenu(false);
            }}
        />
    </div>
}

export default LinkMenu;
